import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "components/common/Box";
import Text from "components/common/Text";
import { withRouter } from "react-router";
import MenuItem from "components/common/MenuItem";
import Select from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "components/common/Button";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import { Formik } from "formik";
import * as yup from "yup";
import { Typography } from "@mui/material";
import Stack from "components/common/Stack";

const MapDetails = ({
  selectlist,
  selecmodeltlist,
  OnmanufactureChange,
  submitPowerMap,
}) => {
  const [selectedVehicle, setSelectedVehicle] = React.useState("");
  const [selectedModel, setSelectedModel] = React.useState("");

  const initialValues = {
    powername: "",
    timename: "",
  };

  const validatePowerForm = yup.object().shape({
    powername: yup
      .string()
      .min(2, "Too Short!")
      .max(4, "Too Long!")
      .required("Value is required")
      .matches(/^[0-9\b]+$/, "Only number are allowed for this field "),

    timename: yup
      .string()
      .min(2, "Too Short!")
      .max(3, "Too Long!")
      .required("Time is required")
      .matches(/^[0-9\b]+$/, "Only number are allowed for this field "),
  });

  const handleClick = async (values, reset) => {
    await submitPowerMap({
      ...values,
      manufacturer_id: selectedVehicle,
      model_id: selectedModel,
    });
    setSelectedModel("");
    setSelectedVehicle("");
    reset();
  };
  let history = useHistory();
  const classes = useStyles();

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { resetForm }) => handleClick(values, resetForm)}
        validationSchema={validatePowerForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
          values,
          touched,
          errors,
        }) => (
          <>
            <Text
              variant="h5"
              color="#202020"
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "40px",
                color: "#1A1A1A",
              }}
            >
              <ArrowBackIcon
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginRight: "10px",
                }}
                onClick={() => history.goBack()}
              />
              Map
            </Text>

            <Grid
              container
              item
              sx={12}
              direction={{ sm: "column", xs: "column", md: "row" }}
            >
              <Grid item xs={4}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Select Vehicle Manufacturer
                </Text>
                <Select
                  fullWidth
                  size="small"
                  sx={{ marginBottom: "15px", fontSize: "14px" }}
                  value={selectedVehicle}
                  onChange={(vehicle) => {
                    setSelectedVehicle(vehicle.target.value);
                    OnmanufactureChange(vehicle.target.value);
                  }}
                >
                  {selectlist?.map((item) => (
                    <MenuItem
                      sx={{ fontSize: "14px" }}
                      key={item}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={4}>
                <Text className={classes.MapHeading}>Select Vehicle Model</Text>
                <Select
                  className={classes.formbox}
                  fullWidth
                  size="small"
                  onChange={(model) => {
                    setSelectedModel(model.target.value);
                  }}
                  value={selectedModel}
                >
                  {selecmodeltlist?.map((item) => (
                    <MenuItem
                      sx={{ fontSize: "14px" }}
                      key={item}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>

            <Grid container item sx={12}>
              <Grid item xs={12} lg={4}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Enter Power (Kw)
                </Text>
                <Box>
                  <TextField
                    fullWidth
                    size="small"
                    onChange={handleChange("powername")}
                    onBlur={handleBlur("powername")}
                    value={values.powername}
                    error={!touched.powername && Boolean(errors.powername)}
                    inputProps={{ style: { fontSize: "14px" }, maxlength: 4 }}
                    onInput={(e) => {
                      e.target.value = e.target.value.trimStart();
                    }}
                  />
                  {errors.powername && (
                    <Typography sx={{ color: "red" }}>
                      {errors.powername}
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Text className={classes.MapHeading}>Enter Time (min)</Text>
                <Box>
                  <TextField
                    className={classes.Textbox}
                    fullwidth
                    size="small"
                    onChange={handleChange("timename")}
                    onBlur={handleBlur("timename")}
                    value={values.timename}
                    error={!touched.timename && Boolean(errors.timename)}
                    inputProps={{ style: { fontSize: "14px" }, maxlength: 3 }}
                    onInput={(e) => {
                      e.target.value = e.target.value.trimStart();
                    }}
                  />
                  {errors.timename && (
                    <Typography sx={{ color: "red" }}>
                      {errors.timename}
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Stack mt={10}>
              <Button
                variant="contained"
                sx={{ width: "114.17px", height: "54px", fontSize: "16px" }}
                onClick={() => {
                  handleSubmit();
                }}
                disabled={!isValid || !selectedVehicle || !selectedModel}
              >
                save
              </Button>
              <br></br>
            </Stack>
          </>
        )}
      </Formik>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  MapHeading: {
    color: "#666666",
    fontSize: "14px",
    marginLeft: "10px",

    "@media (max-width:768px)": {
      marginLeft: "0px",
    },
  },
  formbox: {
    mt: "19",
    fontSize: "14px",
    marginLeft: "10px",

    "@media (max-width:768px)": {
      marginLeft: "0px",
    },
  },
  Textbox: {
    marginLeft: "10px",
    width: "310px",

    "@media (max-width:768px)": {
      marginLeft: "0px",
      width: "296px",
    },
  },
}));

export default withRouter(MapDetails);
